import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import Spinner from "../../../Plateforme/Atoms/Spinner";
import Section from "../../Atoms/Section";
import H1 from "../../Atoms/H1";
import * as api from "../../../api"
import TableAdminData from "../../Components/TableAdminData";
import { AwardsObjectToString, LiensPressesObjectToString, publicToString, semicolonSeparatedToCommadSeparated } from "../../Utils/Format";
import CSVExportButton from "../../Components/CSVExportButton";

const Projects = (props) => {

    const [allProjects, setAllProjects] = useState(null);
    const [tableData, setTableData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if(props.fullUserLoading) return;
        if(!props.fullUser?.user) navigate("/");
        if(props.fullUser?.user && props.fullUser.user.role !== "admin") navigate("/");
    }, [props.fullUserLoading, props.fullUser, navigate])

    useEffect(() => {
        //get active users
        api.GetAllUsers().then(res => {
            const _activeUsers = res.data;
            const _companies = [];
            const _projects = [];
            for(let i = 0; i < _activeUsers.length; i++) {
                const user = _activeUsers[i];

                //for each user, add the company if the ids don't match
                if(user.company && !_companies.find(company => company.company._id === user.company.company._id)){
                    _companies.push(user.company);

                    const owner = _activeUsers.find(_user => _user.user._id === user.company.company.ownerUserId);

                    //for each company, add the projects
                    for(let j = 0; j < user.company.company.projects.length; j++) {
                        const project = user.company.company.projects[j];
                        project.companyId = user.company.company._id;
                        if(!user.company.hsCompany){
                            continue
                        }
                        project.companyName = user.company.hsCompany.properties.name;
                        project.ownerEmail = owner.user.email;
                        _projects.push(project);
                    }
                }
            }
            setAllProjects(_projects)
            
        }
        ).catch(function (error) {
            console.log(error);
        });
    },[]);

    useEffect(() => {
        if(!allProjects) return;
        
        const _tableData = [];
        _tableData.push([
            "Société",
            "Nom",
            "Lien vers le projet",
            "Lien pour éditer le projet",
            "Projet public",
            "Année de livraison",
            "Type",
            "Typologie",
            "Médias",
            "À propos FR",
            "À propos EN",
            "Fabricant",
            "Fabrication Française",
            "Galerie",
            "Client/Commanditaire",
            "Libre à l'édition",
            "Editeur",
            "Adresse du projet",
            "Liens presse",
            "Awards",
        ]);

        for(let i = 0; i < allProjects.length; i++){
            _tableData.push([
                allProjects[i].companyName,
                allProjects[i].name,
                {link : true, value : "https://connectedby.lefrenchdesign.org/project?pid=" + allProjects[i]._id + "&cid=" + allProjects[i].companyId},
                {link : true, value : "https://connectedby.lefrenchdesign.org/myproject?id=" + allProjects[i]._id + "&as=" + btoa(allProjects[i].ownerEmail)},
                publicToString(allProjects[i].public),
                allProjects[i].year,
                allProjects[i].type,
                allProjects[i].typologie,
                médiasToString(allProjects[i].medias),
                allProjects[i].aboutfr,
                allProjects[i].abouten,
                allProjects[i].fabricant,
                allProjects[i].fabrication_fr,
                allProjects[i].galerie,
                allProjects[i].client,
                allProjects[i].libre_edition,
                allProjects[i].editeur,
                allProjects[i].adresse,
                LiensPressesObjectToString(allProjects[i].lien_presse),
                AwardsObjectToString(allProjects[i].awards),
            ]);
        }

        setTableData(_tableData);

    }, [allProjects])

    function médiasToString(medias){
        if(!medias) return "";

        let string = "";
        for(let i = 0; i < medias.length; i++){
            string += process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + medias[i].path;
            string += " crédit : " + medias[i].credit + "";
            string += " légende : " + medias[i].legende + "";
            if(i < medias.length - 1) string += ", ";
        }

        return string;
    }

    if (props.fullUserLoading || !allProjects || !tableData){
        return (<>
            <br/><br/><br/>
            <Spinner/>
        </>)
    }

    return (<>
        <Section className="padding flexblock" style={{justifyContent:"space-between"}}>
            <H1>Projets ({allProjects.length})</H1>
            <CSVExportButton data={tableData} filename="projets.csv"/>
        </Section>
        <Section>
            <TableAdminData data={tableData}/>
        </Section>
    </>)
}

export default Projects;